
import React from "react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

interface LeadAvatarProps {
  fullName: string;
}

export const LeadAvatar = ({ fullName }: LeadAvatarProps) => {
  // Get initials from the full name
  const getInitials = (name: string) => {
    if (!name || name === "Unknown") return "?";
    return name
      .split(' ')
      .map(part => part.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <Avatar className="h-9 w-9 flex-shrink-0">
      <AvatarFallback className="bg-gray-300 text-gray-700 text-xs">
        {getInitials(fullName)}
      </AvatarFallback>
    </Avatar>
  );
};
